function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M37.5555 21.3008L24.6055 10.2172C24.2672 9.9276 23.7328 9.9276 23.3945 10.2172L10.4317 21.3122C10.1575 21.557 10 21.8945 10 22.2393C10 22.957 10.6545 23.5414 11.4583 23.5414H13.5V33.4375C13.5 34.3 14.284 35 15.25 35H20.2083C20.6913 35 21.0833 34.65 21.0833 34.2187V27.4478C21.0833 27.305 21.214 27.1873 21.375 27.1873H26.625C26.7848 27.1873 26.9167 27.305 26.9167 27.4478V34.2187C26.9167 34.65 27.3087 35 27.7917 35H32.75C33.716 35 34.5 34.3 34.5 33.4375V23.5414H36.5417C37.3455 23.5414 38 22.957 38 22.2393C38 21.8945 37.8425 21.557 37.5555 21.3008Z",
  fill: "white"
});
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 45,
    viewBox: "0 0 48 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.6bc9b6693e296a55e27bd5707a6b111c.svg";
export { ForwardRef as ReactComponent };